import React, { PureComponent } from "react";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";

import { LineInput } from "components/Inputs/LineInput";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import CrownIcon from "images/CrownIcon.svg";

import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";

import { UNIFIED_PROJECT_STEPS } from "containers/Business/BusinessReducer";

import MadlibsObjective from "components/Business/ModelBox/MadlibsObjective";
import MadlibsInput from "components/Business/ModelBox/MadlibsInput";

import styles from "./style.module.css";

export default class NextMadLibsBox extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editMode: props.forceShow
    };
  }

  renderContinuousContent(editModeOverride) {
    const {
      updateMadLibs,
      setupLabels,

      isBlueprintPicker,
      outcomeLabel,
      updateOutcomeLabel,
      transactionLabel,
      updateTransactionLabel,
      trueAction,
      updateTrueAction,
      notPursuedTransactionLabel,
      updateNotPursuedTransactionLabel,

      costLabel,
      updateAdvancedCostLabel,
      revenueLabel,
      updateAdvancedRevenueLabel,
      profitLabel,
      updateNetImpactLabel,

      falseAction,
      updateFalseAction,

      unitType,
      updateUnitType,

      setup,
      forceShow,
      isSenseTask
    } = this.props;

    const editMode = editModeOverride !== undefined ? editModeOverride : forceShow || this.state.editMode;

    return (
      <div
        style={isSenseTask ? { height: "calc(100vh - 560px)", overflow: "auto" } : {}}
        className={isBlueprintPicker ? styles.madlibsExplanationBp : styles.madlibsExplanation}
      >
        <div className={styles.madlibsTitle}>{"Add your Use Case Business Language"}</div>
        <div className={styles.madlibsTextBox}>
          <MadlibsObjective
            editMode={editMode}
            itemNumber={1}
            itemContent={
              <React.Fragment>
                {"Aible will optimize your total "}
                <strong>{setupLabels.profitLabel}</strong>
                {" % by minimizing the "}
                <strong>{setupLabels.overPredictAction}</strong>
                {" and "}
                <strong>{setupLabels.underPredictAction}</strong>
              </React.Fragment>
            }
          >
            <MadlibsInput
              label={"The net outcome is called"}
              value={setupLabels.profitLabel}
              onChange={updateNetImpactLabel}
            />
            <MadlibsInput
              label={"A prediction that is too high causes"}
              value={setupLabels.overPredictAction}
              onChange={(val) => updateMadLibs("overPredictAction", val)}
            />
            <MadlibsInput
              label={"A prediction that is too low causes"}
              value={setupLabels.underPredictAction}
              onChange={(val) => updateMadLibs("underPredictAction", val)}
            />
          </MadlibsObjective>
          <MadlibsObjective
            editMode={editMode}
            itemNumber={2}
            itemContent={
              <React.Fragment>
                {"Aible will recomend an optimal "}
                <strong>{setupLabels.numberPredicted}</strong>
                {" for the "}
                <strong>{setupLabels.transactionLabel}</strong>
              </React.Fragment>
            }
          >
            <MadlibsInput
              label={"The number predicted is the"}
              value={setupLabels.numberPredicted}
              onChange={(val) => updateMadLibs("numberPredicted", val)}
            />
            <MadlibsInput
              label={"My transactions are called"}
              value={setupLabels.transactionLabel}
              onChange={updateTransactionLabel}
            />
          </MadlibsObjective>
          <MadlibsObjective
            editMode={editMode}
            itemNumber={3}
            itemContent={
              <React.Fragment>
                {"Aible will evaluate your total "}
                <strong>{setupLabels.profitLabel}</strong>
                {" in units of "}
                <strong>{unitType}</strong>
              </React.Fragment>
            }
          >
            <MadlibsInput
              label={"The unit of measure is (USD, hours, etc)"}
              value={unitType}
              onChange={updateUnitType}
              isWide
            />
          </MadlibsObjective>
          {!forceShow && (
            <Button onClick={() => this.setState({ editMode: !editMode })} style={{ margin: "10px 0px 0px" }}>
              {editMode ? "Close" : "Edit Business Language"}
            </Button>
          )}
        </div>
      </div>
    );
  }

  renderContent() {
    const {
      isContinuous,
      isBlueprintPicker,
      outcomeLabel,
      updateOutcomeLabel,
      transactionLabel,
      updateTransactionLabel,
      trueAction,
      updateTrueAction,
      notPursuedTransactionLabel,
      updateNotPursuedTransactionLabel,

      costLabel,
      updateAdvancedCostLabel,
      revenueLabel,
      updateAdvancedRevenueLabel,
      profitLabel,
      updateNetImpactLabel,

      falseAction,
      updateFalseAction,

      unitType,
      updateUnitType,

      setup,
      forceShow,
      isSenseTask,
      hideUseCaseTitle
    } = this.props;

    const editMode = forceShow || this.state.editMode;

    if (isContinuous) {
      return this.renderContinuousContent(editMode);
    }

    return (
      <div
        style={isSenseTask ? { height: "calc(100vh - 560px)", overflow: "auto" } : {}}
        className={isBlueprintPicker ? styles.madlibsExplanationBp : styles.madlibsExplanation}
      >
        {hideUseCaseTitle === true ? (
          <div />
        ) : (
          <div className={styles.madlibsTitle}>{"Add your Use Case Business Language"}</div>
        )}
        <div className={styles.madlibsTextBox}>
          <MadlibsObjective
            editMode={editMode}
            itemNumber={1}
            itemContent={
              <React.Fragment>
                {"Aible will optimize your "}
                <strong>{outcomeLabel}</strong>
                {" % by recommending which "}
                <strong>{transactionLabel}</strong>
                {" to "}
                <strong>{trueAction}</strong>
                {" from the list of available "}
                <strong>{notPursuedTransactionLabel}</strong>
              </React.Fragment>
            }
          >
            <MadlibsInput label={"The target outcome is a"} value={outcomeLabel} onChange={updateOutcomeLabel} />
            <MadlibsInput
              label={"My transactions are called"}
              value={transactionLabel}
              onChange={updateTransactionLabel}
            />
            <MadlibsInput
              label={
                <React.Fragment>
                  {"If Aible predicts "}
                  <strong>{outcomeLabel}</strong>
                  {" you will "}
                </React.Fragment>
              }
              value={trueAction}
              onChange={updateTrueAction}
              bottomLabel={
                <React.Fragment>
                  {"the "}
                  <strong>{transactionLabel}</strong>
                </React.Fragment>
              }
            />
            <MadlibsInput
              label={
                <React.Fragment>
                  {"Before becoming "}
                  <strong>{transactionLabel}</strong>
                  {" that I "}
                  <strong>{trueAction}</strong>
                  {" or "}
                  <strong>{falseAction}</strong>
                  {", all potential transactions are called "}
                </React.Fragment>
              }
              value={notPursuedTransactionLabel}
              onChange={updateNotPursuedTransactionLabel}
              isWide
            />
          </MadlibsObjective>
          <MadlibsObjective
            editMode={editMode}
            itemNumber={2}
            itemContent={
              <React.Fragment>
                {"Aible will also show how to allocate your "}
                <strong>{costLabel}</strong>
                {" in a way that optimizes "}
                <strong>{revenueLabel}</strong>
                {" and "}
                <strong>{profitLabel}</strong>
              </React.Fragment>
            }
          >
            <MadlibsInput label={"My resourcing is called"} value={costLabel} onChange={updateAdvancedCostLabel} />
            <MadlibsInput
              label={"My gross outcome is called"}
              value={revenueLabel}
              onChange={updateAdvancedRevenueLabel}
            />
            <MadlibsInput label={"My net outcome is called"} value={profitLabel} onChange={updateNetImpactLabel} />
          </MadlibsObjective>
          <MadlibsObjective
            editMode={editMode}
            itemNumber={3}
            itemContent={
              <React.Fragment>
                {"Aible will conserve "}
                <strong>{costLabel}</strong>
                {" by recommending "}
                <strong>{falseAction}</strong>
                {" for "}
                <strong>{notPursuedTransactionLabel}</strong>
                {" where "}
                <strong>{trueAction}</strong>
                {" is less valuable"}
              </React.Fragment>
            }
          >
            <MadlibsInput
              label={
                <React.Fragment>
                  {"If Aible does not predict "}
                  <strong>{outcomeLabel}</strong>
                  {" you will "}
                </React.Fragment>
              }
              bottomLabel={
                <React.Fragment>
                  {"the "}
                  <strong>{notPursuedTransactionLabel}</strong>
                </React.Fragment>
              }
              value={falseAction}
              onChange={updateFalseAction}
              isWide
            />
          </MadlibsObjective>
          <MadlibsObjective
            editMode={editMode}
            itemNumber={4}
            itemContent={
              <React.Fragment>
                {"Aible will evaluate your strategic options in units of "}
                <strong>{unitType}</strong>
              </React.Fragment>
            }
          >
            <MadlibsInput
              label={"The unit of measure is (USD, hours, etc)"}
              value={unitType}
              onChange={updateUnitType}
              isWide
            />
          </MadlibsObjective>
          {!forceShow && (
            <Button onClick={() => this.setState({ editMode: !editMode })} style={{ margin: "10px 0px 0px" }}>
              {editMode ? "Close" : "Edit Business Language"}
            </Button>
          )}
        </div>
      </div>
    );
  }

  renderBackground() {
    const { isContinuous } = this.props;
    if (isContinuous) {
      return (
        <div className={styles.madlibsBackground}>
          {" "}
          <div className={styles.madBarHolder} style={{ marginTop: "5px" }}>
            <div className={styles.modelBar} style={{ width: "300px", background: "#E6E6FC" }} />
          </div>
          <div className={styles.madBarHolder}>
            <div
              className={styles.modelBar}
              style={{
                width: "300px",
                opacity: "0.6",
                borderLeft: "25px solid transparent",
                borderRight: "25px dotted transparent",
                borderTop: "50px solid rgba(239, 239, 242, 1)"
              }}
            />
          </div>
          <div className={styles.madBarHolder}>
            <div
              className={styles.modelBar}
              style={{
                width: "250px",
                opacity: "0.6",
                borderLeft: "25px solid transparent",
                borderRight: "25px dotted transparent",
                borderTop: "50px solid rgba(239, 239, 242, 1)"
              }}
            />
          </div>
          <div className={styles.madBarHolder}>
            <div className={styles.modelBar} style={{ width: "200px", background: "#E6E6FC" }} />
          </div>
        </div>
      );
    }
    return (
      <div className={styles.madlibsBackground}>
        {" "}
        <div className={styles.madBarHolder} style={{ marginTop: "5px" }}>
          <div className={styles.modelBar} style={{ width: "300px", background: "#E6E6FC" }} />
        </div>
        <div className={styles.madBarHolder}>
          <div
            className={styles.modelBar}
            style={{
              width: "300px",
              opacity: "0.6",
              borderLeft: "25px solid transparent",
              borderRight: "25px dotted transparent",
              borderTop: "50px solid rgba(239, 239, 242, 1)"
            }}
          />
        </div>
        <div className={styles.madBarHolder}>
          <div className={styles.modelBar} style={{ width: "250px", background: "#E6E6FC" }} />
        </div>
        <div className={styles.madBarHolder}>
          <div
            className={styles.modelBar}
            style={{
              width: "250px",
              opacity: "0.6",
              borderLeft: "25px solid transparent",
              borderRight: "25px dotted transparent",
              borderTop: "50px solid rgba(239, 239, 242, 1)"
            }}
          />
        </div>
        <div className={styles.madBarHolder}>
          <div className={styles.modelBar} style={{ width: "200px", background: "#E6E6FC" }} />
        </div>
      </div>
    );
  }

  renderFunnelContent() {
    const {
      isContinuous,
      setupLabels,
      id,
      setup,
      dataset,
      isEditBlueprint,
      madlibs,
      outcomeWinRate,
      outcome,
      updateOutcomeLabel,
      updateTransactionLabel,
      updateAdvancedRevenueLabel,
      updateNotPursuedTransactionLabel,
      updateTrueAction,
      updateFalseAction,
      updateTruePositiveLabel,
      updateMadLibs,
      updateCountType,
      updateUnitType,
      transactionLabel,
      outcomeLabel,
      notPursuedTransactionLabel,
      trueAction,
      falseAction,
      unitType,
      truePositiveLabel,
      revenueLabel,
      costLabel,
      profitLabel,
      forceShow
    } = this.props;
    if (isContinuous) {
      return (
        <div className={styles.madlibsContent}>
          <div className={styles.madlibsLineInputWidth}>
            <span style={{ marginRight: "4px" }}>{"Total Potential "}</span>
            <strong>{setupLabels.profitLabel}</strong>
          </div>
          <div className={styles.madlibsLineInputWidth}>
            <span style={{ marginRight: "4px" }}>{"Total after "}</span>
            <strong>{setupLabels.overPredictAction}</strong>
          </div>
          <div className={styles.madlibsLineInputWidth}>
            <span style={{ marginRight: "4px" }}>{"Total after "}</span>
            <strong>{setupLabels.underPredictAction}</strong>
          </div>
          <div className={styles.madlibsLineInputWidth}>
            <span style={{ marginRight: "4px" }}>{"Total "}</span>
            <strong>{setupLabels.profitLabel}</strong>
          </div>
        </div>
      );
    }
    return (
      <div className={styles.madlibsContent}>
        <div className={styles.madlibsLineInputWidth}>
          <strong>{notPursuedTransactionLabel}</strong>
          <span style={{ marginLeft: "4px" }}>{"to predict"}</span>
        </div>
        <div className={styles.madlibsLineInputWidth} style={{ maxWidth: "280px" }}>
          {"HOW WELL YOUR AI HELPS YOU FOCUS ON A FEW THINGS TO ACT ON"}
        </div>
        <div className={styles.madlibsLineInputWidth}>
          <strong>{transactionLabel}</strong>
          <span style={{ margin: "0px 4px" }}>{" to "}</span>
          <strong>{trueAction}</strong>
        </div>
        <div className={styles.madlibsLineInputWidth} style={{ flexDirection: "column", justifyContent: "center" }}>
          <span>{"HOW WELL YOU DO IF YOU ACT ON THE AI IDENTIFIED"}</span>
          <span style={{ fontWeight: "bold", textTransform: "uppercase" }}>{transactionLabel}</span>
        </div>
        <div className={styles.madlibsLineInputWidth}>
          <strong>{transactionLabel}</strong>
          <span style={{ margin: "0px 4px" }}>{" that are a "}</span>
          <strong>{outcomeLabel}</strong>
        </div>
      </div>
    );
  }

  renderFunnel() {
    const {
      isContinuous,
      setupLabels,
      id,
      setup,
      dataset,
      isEditBlueprint,
      madlibs,
      outcomeWinRate,
      outcome,
      updateOutcomeLabel,
      updateTransactionLabel,
      updateAdvancedRevenueLabel,
      updateNotPursuedTransactionLabel,
      updateTrueAction,
      updateFalseAction,
      updateTruePositiveLabel,
      updateMadLibs,
      updateCountType,
      updateUnitType,
      transactionLabel,
      outcomeLabel,
      notPursuedTransactionLabel,
      trueAction,
      falseAction,
      unitType,
      truePositiveLabel,
      revenueLabel,
      costLabel,
      profitLabel,
      forceShow
    } = this.props;

    return (
      <div className={styles.madlibsFunnel} id="madlibsFunnel">
        <div className={styles.madlibsFunnelTitle}>{"The AI Process"}</div>
        <div className={styles.madlibsFunnelWrapper}>
          {this.renderBackground()}
          {this.renderFunnelContent()}
        </div>
      </div>
    );
  }

  render() {
    const {
      id,
      isBlueprintPicker,
      trainAI,
      isNextEnabled,
      hasSetupIgnoreChanged,
      isRetraining,
      retrainRun,
      updateCurrentStep,
      renderFunnel,
      renderContent
    } = this.props;

    const { isCreatingProject } = this.state || {};

    return (
      <div
        className={styles.madlibsBox}
        style={isBlueprintPicker && !renderFunnel ? { marginLeft: "0px", marginTop: "20px" } : {}}
      >
        {renderContent && this.renderContent()}
        {renderFunnel && this.renderFunnel()}
      </div>
    );
  }
}
